import React, { useEffect } from 'react';
import { useState } from 'react';

import t from '../Translation/Translation';
import { IonButtons, IonContent, IonHeader, IonFooter, IonPage, IonTitle, IonToolbar, IonMenuToggle, IonModal, IonButton, IonIcon, IonLabel } from '@ionic/react';
import { Row, Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotate } from '@fortawesome/free-solid-svg-icons';
import { useIonViewWillEnter, useIonViewDidEnter, useIonViewWillLeave } from '@ionic/react';
import { arrowBack } from 'ionicons/icons';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { Avatar, Loader, CustomTable } from 'citric_components';
import Menubar from '../Dashboard/Menubar';
import ReleasesAdmContent from './ReleasesAdmContent';
import { App } from '@capacitor/app';

import CardImg from '../../images/card.png';
import { useNavigate } from 'react-router';

import conf from '../../config.json';
import { formatDate, logD } from '../Util/Util';
import i18next from 'i18next';
import Header from '../Dashboard/Header';

export default function ReleasesAdm(props) {
    logD("ReleasesAdm", props);
    const [launchs, setLaunchs] = useState(props.project.releases);
    const project = props.project;
    const projects = props.projects;

    const navigate = useNavigate();

    function back() {
        props.setCustomer(null);
        //props.setProject(null);
        setTimeout(function(){
            navigate(-1);
        }, 1);
        //navigate.go(-1);
    }

    useIonViewDidEnter(async () => {
        App.addListener('backButton', ({canGoBack}) => {
            
            if(!canGoBack){
                App.exitApp();
            } else {
                back();
            }
        });
    });

    function openURLInNewTab(url) {
        window.open(url, '_blank');
    }

    function loadRelease(item) {
        console.log('loadRelease');
        console.log(item);
        props.setRelease(item);
        setTimeout(function(){
            navigate('../release/'+item.idDraft);
        }, 100);
    }

    function getReleases(item) {
        setLaunchs(null);
        let fd = new URLSearchParams();
        fd.append("idC", props.token.c);
        fd.append("idU", props.token.u);
        fd.append("idP", item.idProject);
        //const url = conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/dash/all';
        const url = conf.BEprotocol + '://' + conf.BEhost + ':' + conf.BEport + '/' + conf.BEcontext + '/rest/action/allReleases';
        fetch(url, {
            method: 'POST',
            headers: {
                'authorization': 'Bearer ' + props.token.token
            },
            body: fd,
        })
        .then((response) => props.handleError(response))
        .then((data) => {
            logD("Projects", data);
            //loadProject(data, refresh);
            props.setProject(data);
            setLaunchs(data.releases);
        }).catch((e) => {
            props.setShowToast(true);
        });
    }

    function reload() {
        setLaunchs(null);
        getReleases(project);
    }

    useEffect(() => {
        if(launchs == null || launchs.length == 0) {
            getReleases(project);
        }
    }, [props]);
    
    return (
        <>
            { props.token.r != 1 && projects.length == 1 && <Menubar lang={props.lang} setLang={props.setLang} token={props.token} setToken={props.setToken} contentId="releasesAdm"/> }
            <IonPage id="releasesAdm">
                <IonHeader>
                    <Header lang={props.lang} setLang={props.setLang} token={props.token} setToken={props.setToken}/>
                    <IonToolbar className="toolbar-azul">
                        <IonButtons slot="start">
                            { /*props.token.r != 1 && projects.length == 1 &&
                                <IonMenuToggle className="ion-padding-start">
                                    <Avatar name={props.token.name.charAt(0).toUpperCase()}/>
                                </IonMenuToggle>*/
                            }
                            { (projects.length > 1 || props.token.r == 1) &&
                                <IonButton onClick={() => back()}><IonIcon icon={arrowBack}></IonIcon></IonButton>
                            }
                        </IonButtons>
                        <IonTitle>{t('surveys')}</IonTitle>
                    </IonToolbar>
                </IonHeader>
                <IonContent className="ion-padding">
                    {launchs == null && <Loader />}
                    {
                        /*launchs != null &&
                        <CustomTable keyField='id' desc={false} data={launchs} columns={columns} isFilter={true} isPagination={true} isSelection={false} hasActions={false} hiddenColumns={hiddenColumns} isExport={true}/>*/
                    }
                    {/*<IonModal className="big-modal" isOpen={modalOpen}>
                        <IonHeader>
                            <IonToolbar>
                                <IonButtons slot="start">
                                    <IonButton onClick={() => setModalOpen(false)}>{t('close')}</IonButton>
                                </IonButtons>
                                <IonTitle>{t('outputs')}</IonTitle>
                            </IonToolbar>
                        </IonHeader>
                        <IonContent className="ion-padding">
                            {   selected != null && selected.outputs != null &&
                                <CustomTable keyField='idOutput' desc={false} data={selected.outputs} columns={columnsOutput} isFilter={true} isPagination={true} isSelection={false} hasActions={false} hiddenColumns={hiddenColumns} isExport={true}/>
                            }
                        </IonContent>
                        </IonModal>*/}
                        <Row className="text-end">
                            <Col>
                                <Button variant="link"><FontAwesomeIcon icon={faRotate} onClick={() => reload()}/></Button>
                            </Col>
                        </Row>
                        {
                        launchs != null &&
                            <ReleasesAdmContent project={props.project} releases={launchs} lang={props.lang} setLang={props.setLang} token={props.token} setUrl={props.setUrl} setTitle={props.setTitle} setTypeUrl={props.setTypeUrl} 
                            setProject={props.setProject} setRelease={props.setRelease} setToken={props.setToken} handleError={props.handleError} setCustomer={props.setCustomer} setShowToast={props.setShowToast} 
                            loadRelease={loadRelease} userConfig={props.userConfig}/>
                        }
                </IonContent>
                <IonFooter>
                    <IonToolbar>
                        <IonTitle className="text-center">{t('logged_in_as')} <span className='color-orange'><b>{props.token.name}</b></span></IonTitle>
                    </IonToolbar>
                </IonFooter>
            </IonPage>
        </>
    );
}